import { FilterContentFieldDataTypes } from '../../filter/constants';
import { Filter } from '../../filter/interface';
import { USAGE_SUMMARY_PIPELINE_TYPE_DISPLAY_DATA, UsageSummaryPipelineType } from './interface';

export function getUsageSummaryFilters(
  isH20Enabled: boolean,
  isMultiRegion: boolean,
  regions?: { label: string; value: string }[]
): Filter[] {
  return [
    {
      title: 'Status',
      filterKey: 'status',
      filterType: FilterContentFieldDataTypes.LIST,
      filterContentProps: {
        multiple: true,
        options: [
          {
            label: 'Active',
            value: 'true'
          },
          {
            label: 'Deleted',
            value: 'false'
          }
        ],
        selectMode: true
      }
    },
    ...(isMultiRegion
      ? [
          {
            title: 'Region',
            filterKey: 'region',
            filterType: FilterContentFieldDataTypes.LIST,
            filterContentProps: {
              multiple: true,
              options: regions,
              selectMode: true
            }
          }
        ]
      : []),
    ...(isH20Enabled
      ? [
          {
            title: 'Pipeline Type',
            filterKey: 'pipelineType',
            filterType: FilterContentFieldDataTypes.LIST,
            filterContentProps: {
              multiple: true,
              options: [
                {
                  label:
                    USAGE_SUMMARY_PIPELINE_TYPE_DISPLAY_DATA[UsageSummaryPipelineType.STANDARD],
                  value: UsageSummaryPipelineType.STANDARD
                },
                {
                  label: USAGE_SUMMARY_PIPELINE_TYPE_DISPLAY_DATA[UsageSummaryPipelineType.EDGE],
                  value: UsageSummaryPipelineType.EDGE
                }
              ],
              selectMode: true
            }
          }
        ]
      : [])
  ];
}
